import { MockedResponse } from '@apollo/client/testing';
import { GET_COMPANIES } from '@bechtel/client-gql';
import { UserSortByTerm, SortOrder, AuthRole, WorkPackageDiscipline, Facility } from '@bechtel/types';
import { t } from '@lingui/macro';
import { Company } from './list/drawer/company-list/types';
import { UserDrawerValuesProps } from './list/drawer/types';

export const userDrawerDefaultValues: UserDrawerValuesProps = {
  sortBy: UserSortByTerm.LAST_NAME,
  sortOrder: SortOrder.ASC,
  companies: [],
  facilities: [],
  roles: [],
  searchKeyword: null,
};

export const sortByList = [
  { id: 1, value: 'LAST_NAME', label: t`Last Name` },
  { id: 2, value: 'FIRST_NAME', label: t`First Name` },
];

const companyList: Company[] = [
  { id: '1', name: 'Bechtel' },
  { id: '2', name: 'Client' },
  { id: '3', name: 'Company A' },
];

export const companyListMockQueryData: MockedResponse = {
  request: {
    query: GET_COMPANIES,
    variables: {
      input: { searchKeyword: '' },
      pagingInput: { cursor: '1', limit: 50 },
    },
  },
  result: () => {
    return {
      data: { loadCompanies: [...companyList] },
    };
  },
};

export interface FormikState {
  roles: AuthRole[];
  disciplines: WorkPackageDiscipline[];
  company: Company | null;
  facilities: Facility[];
  isActive: boolean;
  jobTitle: string | null;
  becimsId: string | null;
  firstName: string | null;
  lastName: string | null;
  lobEmployeeId: string | null;
  bun: string | null;
}
